import { usePageTitle } from '@btime/react-hooks'
import React from 'react'

import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import DocumentFormatButton from './DocumentFormatButton'

const PageHeader = ({ templateId }) => {
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()
  let title

  switch (templateId) {
    case 1:
      title = 'Manutenção Preventiva FM200'
      break
    case 2:
      title = `Manutenção Preventiva SADAI ${serviceOrder?.place?.resume}`
      break
    case 3:
      title = 'Manutenção Preventiva CO2 Resinas'
      break
    case 4:
      title = 'Manutenção Preventiva CO2 LNP'
      break
    case 5:
      title = `Relatório de Manutenção SDAI ${serviceOrder?.place?.resume}`
      break
    default:
      title = 'Relatório'
      break
  }

  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<DocumentFormatButton name={title} recordId={11} templateId={templateId} />}
    />
  )
}

export default PageHeader
